module.exports = __webpack_public_path__ + "img/abacus_type_6.89d49389.png";